import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import { Select, Form } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const { Option } = Select

const TagSelectInput = ({ tags }) => {
  return (
    <>
      <span>{FIELD_LABEL.TAGS}</span>
      <Form.Item
        name={FIELD_NAME.TAG_UUID}
      >
        <Select
          bordered={false}
          mode='multiple'
          placeholder={'Tags'}
          showSearch={false}
          size='large'
          style={{ background: '#fff' }}
        >
          {tags.map(({ name, uuid }) => {
            return (
              <Option
                key={uuid}
                value={uuid}
              >
                {_.startCase(name)}
              </Option>
            )
          })}
        </Select>
      </Form.Item>
    </>
  )
}

TagSelectInput.propTypes = {
  tags: PropTypes.array
}

export default TagSelectInput
